import React from 'react';
import {createRoot, hydrateRoot} from 'react-dom/client';
import './index.scss';
import 'leaflet/dist/leaflet.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
    // Pre-rendered markup present → hydrate.
    hydrateRoot(rootElement, <App/>);
} else {
    // SPA boot. Use createRoot (the React 18 API) rather than the legacy
    // ReactDOM.render — legacy render opts the whole app into React-17
    // compatibility mode, which DISABLES automatic batching of setState
    // outside React event handlers. That made StationDashboard's getData()
    // fire ~7 separate synchronous re-renders (one per setState after the
    // `await`) instead of one batched render — a major contributor to the
    // data-update freeze. createRoot batches them into a single render.
    createRoot(rootElement).render(<App/>);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for PWA functionality
// serviceWorkerRegistration.register(); // Temporarily disabled for testing
